import { useCallback, useEffect, useState } from 'react'

type StateWithCallback<T> = {
  value: T
  onChange: (() => void) | null
}

export default function useStateWithCallback<T>(value: T, onChange: (() => void) | null) {
  const [state, changeState] = useState<StateWithCallback<T>>({ value, onChange })

  useEffect(() => {
    if (state?.onChange) {
      state.onChange()
    }
  }, [state])

  const setState = useCallback(
    (newState: StateWithCallback<T>) => {
      if (JSON.stringify(newState) !== JSON.stringify(state)) {
        changeState(newState)
      }
    },
    [state],
  )

  return { state, setState }
}
